import Vue from "vue";
import register from "../../components/Register"; // 引入弹窗组件

const RegisterDialog = Vue.extend(register);

register.install = function (data) {
  let instance = new RegisterDialog({
    data,
  }).$mount();

  document.body.appendChild(instance.$el);

  Vue.nextTick(() => {
    instance.open();
  });
};

export default register;
